'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _glamor = require('glamor');

var _reactBurgerMenu = require('react-burger-menu');

var _Container = require('./Container');

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------


// ----------------------------------- Components


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract
var Fragment = _react2.default.Fragment;

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Desktop Header

var desktopHeader = (0, _glamor.css)({
  WebkitTransition: 'all 100ms cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  transition: 'all 100ms cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  width: '100%',
  zIndex: '100',
  background: 'transparent',
  display: 'flex'
});
var desktopHeaderClass = desktopHeader.toString();

var desktopQueryToogle = (0, _glamor.css)({
  display: 'none',

  '@media(min-width: 769px)': {
    display: 'block'
  }
});
var desktopQueryToogleClass = desktopQueryToogle.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Mobile Header
var mobileHeader = (0, _glamor.css)({
  WebkitTransition: 'all 100ms cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  transition: 'all 100ms cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& .mobile-header-logo img': {
    display: 'inline-block',
    marginLeft: 15,
    height: 'inherit'
  },

  '& .mobile-header-icon': {
    display: 'inline-block',
    padding: 0,
    margin: 0,
    background: 'transparent',
    border: 'transparent',
    height: 'inherit',
    width: 60,
    marginRight: 15,

    '& img': {
      display: 'inline',
      height: 'inherit',
      width: 'inherit'
    }
  }
});
var mobileHeaderClass = mobileHeader.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Mobile Menu
var mobileQueryToogle = (0, _glamor.css)({
  display: 'none',

  '@media(max-width: 768px)': {
    display: 'block',
    position: 'relative',

    '& #sidebar': {
      top: 0
    },

    '& .bm-morph-shape': {
      fill: '#FFFFFF'
    },

    '& .bm-menu': {
      width: 'calc(100% - 110px) !important',
      background: '#FFFFFF'
    },

    '& .bm-item-list': {
      color: '#363636'
    },

    '& .bm-overlay': {
      background: 'transparent !important'
    }
  }
});
var mobileQueryToogleClass = mobileQueryToogle.toString();

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------- Components
// ------------------------------------------------------------------------------
/**
 * MobileHeader
 */
var MobileHeader = function MobileHeader(props) {
  return _react2.default.createElement(
    Fragment,
    null,
    props.children
  );
};

/**
 * MobileMenu
 */
var MobileMenu = function MobileMenu(props) {
  return _react2.default.createElement(
    Fragment,
    null,
    props.children
  );
};

/**
 * DesktopHeader
 */
var DesktopHeader = function DesktopHeader(props) {
  return _react2.default.createElement(
    Fragment,
    null,
    props.children
  );
};

/* eslint-disable prefer-template */
/**
 * ResponsiveHeader
 */

var ResponsiveHeader = function (_React$Component) {
  _inherits(ResponsiveHeader, _React$Component);

  /**
   * constructor - Just a standard constructor.
   */
  function ResponsiveHeader(props) {
    _classCallCheck(this, ResponsiveHeader);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      sidebarOpen: false
    };

    _this.onSidebarOpen = _this.onSidebarOpen.bind(_this);
    _this.closeSidebar = _this.closeSidebar.bind(_this);
    return _this;
  }

  /**
   * Close the sidebar if URL changes
   */


  ResponsiveHeader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.path !== nextProps.path) {
      this.closeSidebar();
    }
  };

  /**
   * Just an updater, only used indirectly
   */


  ResponsiveHeader.prototype.onSidebarOpen = function onSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  };

  /**
   * Closes the sidebar
   */


  ResponsiveHeader.prototype.closeSidebar = function closeSidebar() {
    this.setState({ sidebarOpen: false });
  };

  /**
   * render - Standard renderer.
   */


  ResponsiveHeader.prototype.render = function render() {
    var children = _react2.default.Children.toArray(this.props.children);
    // Get children
    var childMobileHeader = !_lodash2.default.isUndefined(children) && _lodash2.default.find(children, function (d) {
      return d.type.displayName === 'MobileHeader';
    });
    var childMobileMenu = !_lodash2.default.isUndefined(children) && _lodash2.default.find(children, function (d) {
      return d.type.displayName === 'MobileMenu';
    });
    var childDesktopHeader = !_lodash2.default.isUndefined(children) && _lodash2.default.find(children, function (d) {
      return d.type.displayName === 'DesktopHeader';
    });

    // Get children of mobile header
    var mobileHeaderChildren = !_lodash2.default.isUndefined(childMobileHeader) && childMobileHeader.props.children;
    var mobileHeaderImage = !_lodash2.default.isUndefined(mobileHeaderChildren) && _lodash2.default.find(mobileHeaderChildren, function (d) {
      return d.props.id === 'logo';
    });

    // Burger Menu Image
    var mobileBurgerMenuImage = !_lodash2.default.isUndefined(mobileHeaderChildren) && _lodash2.default.find(mobileHeaderChildren, function (d) {
      return d.props.id === 'menu';
    });
    var mobileBurgerMenuImageStyle = !_lodash2.default.isUndefined(mobileHeaderChildren) ? mobileBurgerMenuImage.props.style : {};

    // Burger Cross Image
    var mobileBurgerCrossImage = !_lodash2.default.isUndefined(mobileHeaderChildren) && _lodash2.default.find(mobileHeaderChildren, function (d) {
      return d.props.id === 'cross';
    });
    var mobileBurgerCrossImageStyle = !_lodash2.default.isUndefined(mobileHeaderChildren) ? mobileBurgerCrossImage.props.style : {};

    // Styles for burger images
    var bmBurgerButtons = (0, _glamor.css)({
      '@media(max-width: 768px)': {
        '& .bm-burger-button': _extends({
          position: 'absolute'
        }, mobileBurgerMenuImageStyle),
        '& .bm-cross-button': {
          height: !_lodash2.default.isUndefined(mobileBurgerCrossImageStyle.height) ? mobileBurgerCrossImageStyle.height + 'px !important' : 24,
          width: !_lodash2.default.isUndefined(mobileBurgerCrossImageStyle.width) ? mobileBurgerCrossImageStyle.width + 'px !important' : 24
        }
      }
    });
    var bmBurgerButtonsClass = bmBurgerButtons.toString();

    // Styles for inner menu
    var innerMenuClass = !_lodash2.default.isUndefined(childMobileMenu) && childMobileMenu.props.className ? childMobileMenu.props.className : '';

    return _react2.default.createElement(
      _Container2.default,
      {
        noFade: true,
        block: true,
        bleed: !_lodash2.default.isUndefined(this.props.bleed) && this.props.bleed === true,
        style: { padding: 0 }
      },
      _react2.default.createElement(
        Fragment,
        null,
        !_lodash2.default.isUndefined(mobileHeaderChildren) && !_lodash2.default.isUndefined(mobileHeaderImage) && !_lodash2.default.isUndefined(mobileBurgerMenuImage) && !_lodash2.default.isUndefined(mobileBurgerCrossImage) && _react2.default.createElement(
          'div',
          {
            className: mobileQueryToogleClass + ' ' + bmBurgerButtonsClass
          },
          _react2.default.createElement(
            'div',
            {
              className: '' + mobileHeaderClass + (!_lodash2.default.isUndefined(childMobileHeader) && childMobileHeader.props.className ? ' ' + childMobileHeader.props.className : '')
            },
            _react2.default.createElement(
              'a',
              { className: 'mobile-header-logo', href: '/' },
              mobileHeaderImage
            )
          ),
          _react2.default.createElement(
            _reactBurgerMenu.elastic,
            {
              width: '100%',
              id: 'sidebar',
              right: true,
              style: { position: 'absolute', top: 0 },
              customBurgerIcon: mobileBurgerMenuImage,
              customCrossIcon: mobileBurgerCrossImage,
              menuClassName: innerMenuClass,
              bodyClassName: 'menu-active',
              isOpen: this.state.sidebarOpen
            },
            childMobileMenu
          )
        ),
        !_lodash2.default.isUndefined(childDesktopHeader) && _react2.default.createElement(
          'div',
          { className: desktopQueryToogleClass },
          _react2.default.createElement(
            'div',
            {
              className: '' + desktopHeaderClass + (!_lodash2.default.isUndefined(childDesktopHeader) && childDesktopHeader.props.className ? ' ' + childDesktopHeader.props.className : '')
            },
            childDesktopHeader
          )
        )
      )
    );
  };

  return ResponsiveHeader;
}(_react2.default.Component);
/* eslint-enable prefer-template */

// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Typings
// ------------------------------------------------------------------------------


MobileHeader.displayName = 'MobileHeader';
MobileHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]).isRequired
} : {};

MobileMenu.displayName = 'MobileMenu';
MobileMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]).isRequired
} : {};

DesktopHeader.displayName = 'DesktopHeader';
DesktopHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]).isRequired
} : {};

ResponsiveHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Specific props
  path: _propTypes2.default.object, // eslint-disable-line
  bleed: _propTypes2.default.bool,

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Generic props
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  style: _propTypes2.default.object, // eslint-disable-line
  className: _propTypes2.default.string // eslint-disable-line
} : {};

ResponsiveHeader.defaultProps = {
  style: {},
  className: undefined,
  bleed: undefined,
  path: undefined
};

// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
var ComposedComponent = {
  ResponsiveHeader: ResponsiveHeader,
  DesktopHeader: DesktopHeader,
  MobileHeader: MobileHeader,
  MobileMenu: MobileMenu
};

exports.default = ComposedComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/components/lib/CompositeHeader.js
// module id = 429
// module chunks = 168707334958949